"use strict";
exports.__esModule = true;
var config = {
    SPORTNET_ONLINE_BASE_URL: 'https://sportnet.online/',
    SPORTNET_ONLINE_LOGO_DARK_URL: '/sportnet-online-logo-dark.svg',
    SPORTNET_ONLINE_LOGO_LIGHT_URL: '/sportnet-online-logo-light.svg'
};
exports["default"] = config;
